import { gql } from 'apollo-angular';

export const intercomMessengerTokenQuery = gql`
  query IntercomMessengerToken {
    intercomMessengerToken
  }
`;
